/** Rótulos amigáveis para campos fiscais (sem expor tags XML na interface). */

export const TPAG_LABELS = {
  '01': 'Dinheiro',
  '02': 'Cheque',
  '03': 'Cartão de crédito',
  '04': 'Cartão de débito',
  '05': 'Crédito loja',
  '10': 'Vale alimentação',
  '11': 'Vale refeição',
  '12': 'Vale presente',
  '13': 'Vale combustível',
  '14': 'Duplicata mercantil',
  '15': 'Boleto bancário',
  '16': 'Depósito bancário',
  '17': 'PIX',
  '18': 'Transferência bancária / carteira digital',
  '19': 'Programa de fidelidade / cashback / crédito virtual',
  '20': 'PIX estático',
  '21': 'Crédito em loja',
  '22': 'Pagamento eletrônico não informado',
  '90': 'Sem pagamento',
  '99': 'Outros',
};

/** Nome legível da forma de pagamento fiscal. */
export function getFormaPagamentoLabel(tPag, xPag) {
  const code = String(tPag ?? '').padStart(2, '0');
  const base = TPAG_LABELS[code] || `Forma ${code}`;
  if (code === '99' && xPag) return `${base} — ${xPag}`;
  if (code === '90') return base;
  return base;
}

export const PAIS_LIST = [
  { code: 1058, name: 'Brasil' },
  { code: 2496, name: 'Estados Unidos' },
  { code: 639, name: 'Argentina' },
  { code: 5860, name: 'Paraguai' },
  { code: 8451, name: 'Uruguai' },
  { code: 1589, name: 'Chile' },
  { code: 2755, name: 'França' },
  { code: 230, name: 'Alemanha' },
  { code: 2453, name: 'Espanha' },
  { code: 3867, name: 'Itália' },
  { code: 6076, name: 'Portugal' },
  { code: 6289, name: 'Reino Unido' },
  { code: 3999, name: 'Japão' },
  { code: 1600, name: 'China' },
];

export function paisLabel(code) {
  const n = Number(code);
  const found = PAIS_LIST.find((p) => p.code === n);
  return found?.name || (n ? `País ${n}` : '');
}
